import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { LangUtils } from '../../service/Lang/Lang';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { Lang } from '../../typings/common';
import { ConstAlertData } from '../../typings/constants';
import { Shape2, Shape2Icon, Shape2Theme, Shape2Tone } from '../Shape2/Shape2';

import './NotificationError.css';

export interface NotificationErrorProps {
    alertData?: ConstAlertData;
}

export interface NotificationErrorState {
    isShown: boolean;
}

export class NotificationError extends React.Component<
    NotificationErrorProps,
    NotificationErrorState
> {
    private block = 'notification-error';

    constructor(props: NotificationErrorProps) {
        super(props);

        this.state = {
            isShown: true
        };
    }

    render() {
        const { alertData } = this.props;
        const { isShown } = this.state;
        const currentLang = LangUtils.getCurrentLang();

        if (!alertData || !alertData.enabled || !isShown) {
            return null;
        }

        return (
            <div className={Bem.cls(this.block)}>
                <div className={Bem.cls(this.block, 'content')}>
                    <Shape2
                        icon={Shape2Icon.warning}
                        width={20}
                        height={20}
                        tone={Shape2Tone.white}
                        cls={Bem.cls(this.block, 'icon-attention')}
                    />
                    <div className={Bem.cls(this.block, 'text')}>
                        {currentLang === Lang.ru
                            ? alertData.textRu
                            : alertData.textEn}
                    </div>
                </div>
                <div className={Bem.cls(this.block, 'close-control')}>
                    <Shape2
                        cls={Bem.cls(this.block, 'icon-close')}
                        icon={Shape2Icon.close}
                        width={14}
                        height={14}
                        theme={Shape2Theme.light}
                        tone={Shape2Tone.white}
                        onClick={this.onClickCloseButton}
                    />
                </div>
            </div>
        );
    }

    private onClickCloseButton = () => {
        this.setState({ isShown: false });
        LocalStorage.setItem(
            StorageKeyType.timestampLastViewNotificationError,
            Date.now()
        );
    };
}
